import { render, staticRenderFns } from "./footer_merced.vue?vue&type=template&id=ef30f64a&"
import script from "./footer_merced.vue?vue&type=script&lang=js&"
export * from "./footer_merced.vue?vue&type=script&lang=js&"
import style0 from "./footer_merced.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports